import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const rootElement = document.getElementById("root");
const app = (
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>
);

if (rootElement?.hasAttribute("data-static-prerendered")) {
  rootElement.removeAttribute("data-static-prerendered");
  hydrateRoot(rootElement, app);
} else {
  if (rootElement?.hasAttribute("data-edge-prerendered")) {
    rootElement.replaceChildren();
    rootElement.removeAttribute("data-edge-prerendered");
  }
  createRoot(rootElement).render(app);
}
